import { render, staticRenderFns } from "./VitaminaA.vue?vue&type=template&id=4a512db3&scoped=true&"
import script from "./VitaminaA.vue?vue&type=script&lang=js&"
export * from "./VitaminaA.vue?vue&type=script&lang=js&"
import style0 from "./VitaminaA.vue?vue&type=style&index=0&id=4a512db3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a512db3",
  null
  
)

export default component.exports